export default __webpack_public_path__ + "static/media/ci_daily_offers.082522f6.png";